import moment from "moment";

import { APP_DOMANIN } from "../../costants";

/**
 * Ritorna il valore di un cookie in base al nome
 * @param name il nome del cookie
 * @returns il valore sse esiste, undefined altrimenti
 */
export function getCookie (name: string) : string | undefined  {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return (match) ? match[2] : undefined;
}

/**
 * scrive un cookie
 * @param cookieData  i dati da associare al cookie
 */
export function writeCookie (cookieData: any) {
    if(!cookieData?.domain){
        cookieData.domain = APP_DOMANIN
    }
    if(!cookieData?.path){
        cookieData.path = '/';
    }
    if(!cookieData?.expires){
        const dt = new Date();
        dt.setTime(dt.getTime() + (60 * 60 * 24 * 30));
        cookieData.expires = `${getUtcStringTimezone(dt)}`;
    }
    else if(cookieData.expires instanceof Date){
        cookieData.expires = `${getUtcStringTimezone(cookieData.expires)}`;
    }
    else{
        const dt = new Date(cookieData.expires);
        cookieData.expires = `${getUtcStringTimezone(dt)}`;
    }
    if(!cookieData?.SameSite){
        cookieData.SameSite = "Lax";
    }

    const hostOnly = (cookieData.hostOnly !== undefined) ? `; hostOnly= ${cookieData.hostOnly}` : "";

    document.cookie = `${cookieData.name}=${cookieData.value}; domain=${cookieData.domain}; path=${cookieData.path}; expires=${cookieData.expires}; samesite=${cookieData.SameSite}${hostOnly}`;
}

function getUtcStringTimezone (date: Date) : String {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000
    date.setTime(
        (timeOffsetInMS >= 0)
            ? date.getTime() + timeOffsetInMS
            : date.getTime() - timeOffsetInMS
    )

    return date.toUTCString()
}

/**
 * cancella un cookie
 * @param cName l'eventuale nome del cookie
 * @param domain l'eventuale dominio del cookie
 * @param path l'eventuale path del cookie
 * @param cookie gli eventuali dati del cookie
 */
export function deleteCookie (cName?: string, domain?: string, path?: string, cookieData? : any) {
    if (cookieData) {
        cName = cookieData.name
        domain = cookieData.domain
        path = cookieData.path
    }
    document.cookie = `${cName}=; domain=${domain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

/**
 * Esegue una chiamata autenticata con il contenuto del token
 * @param url 
 * @param requestParam 
 * @returns 
 */
export function authFetch (
    url: string, 
    requestParam: any,
    expiredSessionCallbak: Function
) {
    const request = requestParam ?? {}

    const jwtCookie = getCookie ('jwt')

    const requestHeaders: HeadersInit = new Headers()

    requestHeaders.append('Content-Type', 'application/json; charset="utf-8"')

    if (jwtCookie) {
        requestHeaders.append('Authorization', `Bearer ${jwtCookie}`);
    }

    request.headers = requestHeaders

    const expireTime = moment(new Date()).add(2, 'hours').toDate()

    const cookie : any = {
        name: "jwt",
        domain: `.${APP_DOMANIN}`,
        path: "/",
        expires: expireTime
    }

    if (APP_DOMANIN.includes('localhost'))  {
        cookie.domain = "localhost"
        cookie.hostOnly = true
        cookie.SameSite = "no_restriction"
    }

    return fetch (
        url, 
        request
    )
    .then ( response => {
        if ( response.headers.get("content-type") === "application/json" ) {

            const token = response.headers.get("x-token") ?? undefined;

            if( token ) {
                cookie.value = token
                writeCookie (cookie)
            }

            return response.json()
        }
    })
    .then ( responseJson => {
        if (
            responseJson?.msg === "TOKEN_EXPIRED" || 
            responseJson?.error_code === "TOKEN_EXPIRED" || 
            responseJson?.error_msg === "MISSING_TOKEN"
        ) {
            deleteCookie( cookie )

            if (expiredSessionCallbak) {
                expiredSessionCallbak(true)
            }
        }

        return responseJson
    })
    .catch ( error => {
        return Promise.reject(error)
    })
}
